/** Resolve assignments in the current organisation; agents retain the master customer. */
export function catalogCustomerForOrder(order, entityId) {
    if (entityId != null && order?.buyer_data?.owner != null &&
        String(order.buyer_data.owner) === String(entityId)) {
        return order.buyer_data;
    }
    return order?.parent_data?.buyer != null ? order.parent_data.buyer_data : order?.buyer_data;
}

export function catalogCustomerIdForOrder(order, entityId) {
    const customer = catalogCustomerForOrder(order, entityId);
    return customer?.id ?? order?.parent_data?.buyer ?? order?.buyer ?? null;
}

/** Customer statistics are private to the organisation owning the customer. */
export function canReadCatalogCustomerForOrder(order, entityId) {
    const customer = catalogCustomerForOrder(order, entityId);
    return customer?.owner != null && entityId != null &&
        String(customer.owner) === String(entityId);
}
